import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';
import { ToastContainer } from 'react-toastify';
import { themed } from '@/shared/ui/core';

const modifiers = {
  static: () => ({
    styles: `
      &&&.Toastify__toast-container {
        position: static !important;
        width: 100% !important;
        padding: unset !important;
        margin: unset !important;
      }
    `,
  }),
};

export const StyledToastContainer = styled(ToastContainer)`
  .Toastify__toast-body {
    padding: unset !important;
  }

  .Toastify__progress-bar--success {
    background: ${themed('primary.darkenGreen')};
  }

  .Toastify__toast--success {
    background: ${themed('primary.lightGreen')};
  }

  .Toastify__toast--error {
    background: ${themed('status.error.light')};
  }

  ${applyStyleModifiers(modifiers)}
`;
